import { createSlice } from '@reduxjs/toolkit';

interface IFiltersWorkOrderSlice {
    filters: Record<string, any>;
}

export const initialState: IFiltersWorkOrderSlice = {
    filters: {},
};

export const filtersWorkOrderSlice = createSlice({
    name: 'filtersWorkOrder',
    initialState,
    reducers: {
        setFiltersWorkOrder: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const filtersWorkOrderSelectors = {
    getFiltersWorkOrder: (state: IFiltersWorkOrderSlice) => state,
};
